import React from "react";

/**
 * DentDefter "DD" logo — two interlocking D's forming a tooth silhouette.
 * Uses gradient teal → emerald matching brand palette.
 */
export default function Logo({ size = 36, className = "" }) {
    return (
        <div
            className={`inline-flex items-center justify-center ${className}`}
            style={{ width: size, height: size }}
            aria-label="DentDefter"
        >
            <svg
                viewBox="0 0 48 48"
                width={size}
                height={size}
                xmlns="http://www.w3.org/2000/svg"
            >
                <defs>
                    <linearGradient id="dd-g" x1="0" y1="0" x2="1" y2="1">
                        <stop offset="0%" stopColor="#0F4C5C" />
                        <stop offset="100%" stopColor="#00A896" />
                    </linearGradient>
                    <linearGradient id="dd-hi" x1="0" y1="0" x2="0" y2="1">
                        <stop offset="0%" stopColor="#ffffff" stopOpacity="0.35" />
                        <stop offset="100%" stopColor="#ffffff" stopOpacity="0" />
                    </linearGradient>
                </defs>
                {/* rounded background */}
                <rect
                    x="1"
                    y="1"
                    width="46"
                    height="46"
                    rx="12"
                    fill="url(#dd-g)"
                />
                <rect
                    x="1"
                    y="1"
                    width="46"
                    height="20"
                    rx="12"
                    fill="url(#dd-hi)"
                />
                {/* Left D */}
                <path
                    d="M11 13h6.5c4.7 0 8 3.5 8 8v6c0 4.5-3.3 8-8 8H11V13zm5 5v12h1.5c2 0 3.5-1.6 3.5-4v-4c0-2.4-1.5-4-3.5-4H16z"
                    fill="#ffffff"
                />
                {/* Right D */}
                <path
                    d="M23 13h6.5c4.7 0 8 3.5 8 8v6c0 4.5-3.3 8-8 8H23V13zm5 5v12h1.5c2 0 3.5-1.6 3.5-4v-4c0-2.4-1.5-4-3.5-4H28z"
                    fill="#ffffff"
                    fillOpacity="0.9"
                />
                {/* tooth spark accent */}
                <circle cx="39" cy="10" r="2" fill="#F4A261" />
            </svg>
        </div>
    );
}
